/**
 * 	Der Eventbus hilft bei der Kommunikation zwischen
 * 	Komponenten und Views untereinander.
 */
import Vue from 'vue';
export const EventBus = new Vue();